export enum DomainVerificationMethod {
    TXT_RECORD = 'TXT_RECORD',
    WEBSITE_CONTENT = 'WEBSITE_CONTENT',
    ADMIN_ASSIGNED = 'ADMIN_ASSIGNED',
}